<template>
    <b-modal id="createModal" size="md" body-class="px-0" ref="modal" title="Create a Withholding Period"
             v-model="show"
             @ok="handleSubmit"
             @hide="close"
             @shown="focusPeriodInput">

        <div class="card card-flat mb-0">

            <div class="card-body">

                <div class="form-group">
                    <label>Period</label>
                    <div class="position-relative">
                        <input type="number" ref="periodInput"
                               name="contamination_period"
                               v-validate="{required: true}"
                               class="form-control"
                               v-model="contaminationPeriod"
                               placeholder="Period of Time in Days">

                        <div class="invalid-feedback" v-if="errors.has('contamination_period')">{{ errors.first('contaminationPeriod') }}</div>
                        <i class="form-group__bar"></i>
                    </div>
                </div>

                <div class="form-group">
                    <label>Country</label>
                    <div class="position-relative">
                        <VueSelect
                                v-model="country"
                                :options="countries"
                                v-validate="{required: true}"
                                data-vv-name="country_id"
                                data-vv-as="country"
                                placeholder="Country"
                                label="name"
                                track-by="id"
                        >
                        </VueSelect>
                        <div class="invalid-feedback" v-if="errors.has('country_id')">{{ errors.first('country_id') }}</div>
                        <i class="form-group__bar"></i>
                    </div>
                </div>

                <div class="form-group">
                    <label>Chemical</label>
                    <div class="position-relative">
                        <VueSelect
                                v-model="chemical"
                                :options="chemicals"
                                v-validate="{required: true}"
                                data-vv-name="chemical_id"
                                data-vv-as="chemical"
                                placeholder="Chemical"
                                label="name"
                                track-by="id"
                        >
                        </VueSelect>
                        <div class="invalid-feedback" v-if="errors.has('chemical_id')">{{ errors.first('chemical_id') }}</div>
                        <i class="form-group__bar"></i>
                    </div>
                </div>

                <div class="form-group">
                    <label>Variety Group</label>
                    <div class="position-relative">
                        <VueSelect
                                v-model="varietyGroup"
                                :options="varietyGroups"
                                v-validate="{required: true}"
                                data-vv-name="variety_group_id"
                                data-vv-as="variety group"
                                placeholder="Variety Group"
                                label="name"
                                track-by="id"
                        >
                        </VueSelect>
                        <div class="invalid-feedback" v-if="errors.has('variety_group_id')">{{ errors.first('variety_group_id') }}</div>
                        <i class="form-group__bar"></i>
                    </div>
                </div>

            </div>
        </div>

        <template slot="modal-footer">
            <button class="btn btn-secondary" @click="close">
                Cancel
            </button>
            <button class="btn btn-primary" @click="handleSubmit">
                Save
            </button>
        </template>
    </b-modal>
</template>


<script>
import listWithholdingPeriodQuery from '@views/WithholdingPeriods/Browse/queryListWithholdingPeriods.graphql';
import createWithholdingPeriodMutation from '@views/WithholdingPeriods/CreateModal/mutationCreateWithholdingPeriod.graphql';

export default {
  name: 'create-modal',
  apollo: {},
  props: ['close', 'chemicals', 'countries', 'varietyGroups', 'cropTypeId'],
  data() {
    return {
      loading: 0,
      show: true,
      contaminationPeriod: null,
      country: null,
      chemical: null,
      varietyGroup: null,
    };
  },
  computed: {
    okDisabled() {
      return this.name.length === 0;
    },
  },
  methods: {
    handleSubmit() {
      this.errors.remove('global');
      this.$validator.validateAll().then(validationWasSuccessful => {
        if (!validationWasSuccessful) {
          return;
        }

        let refetchQueries;

        if (this.cropTypeId) {
          refetchQueries = [
            { query: listWithholdingPeriodQuery, variables: { input: { include_deleted: true, crop_type_id: this.cropTypeId } } },
            { query: listWithholdingPeriodQuery, variables: { input: { crop_type_id: this.cropTypeId } } },
          ];
        } else {
          refetchQueries = [
            { query: listWithholdingPeriodQuery, variables: { input: { include_deleted: true } } },
            { query: listWithholdingPeriodQuery },
          ];
        }

        this.$apollo.mutate({
            mutation: createWithholdingPeriodMutation,
            refetchQueries,
            variables: {
              input: {
                contamination_period: this.contaminationPeriod,
                chemical_id: this.chemical.id,
                variety_group_id: this.varietyGroup.id,
                country_id: this.country.id,
              },
            },
          })
          .then(() => {
            this.$notifySuccess('Withholding Period created!');
            this.close();
          })
          .catch(err => this.$mapGraphQLError(err))
          .catch(err => {
            console.error(err);
            this.$notifyFailure('Unfortunately, we were unable to do that!');
          });
      });
    },
    focusPeriodInput() {
      this.$refs.periodInput.focus();
    },
  },
};
</script>
